import ErrorMessage from "components/ErrorMessage";
import { useForm, Controller } from "react-hook-form";
import { apiGet, apiPost } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import React, { useCallback, useEffect, useState } from "react";

const AddFAQ = ({ setShowModal, getAllFAQ }) => {
  const { t } = useTranslation();
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      showInWebsite: true,
      showInAgentApp: true,
      showInCustomerApp: true,
    },
  });

  const notification = useToastContext();
  const handleSubmitForm = async (data) => {
    try {
      data = {
        ...data,
        projectId: [...selectedProject.map((projectId) => projectId)],
        category: selectedCategory,
      };
      const path = apiPath.getFAQs;
      const result = await apiPost(path, data);
      if (result?.data?.success === true) {
        notification.success(result?.data?.message);
        getAllFAQ();
        setShowModal(false);
      } else {
        notification.error(result?.data?.message);
      }
    } catch (error) {
      console.log("error:", error.message);
    }
  };

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  const getProjects = useCallback(async () => {
    try {
      const payload = {};
      const path = apiPath.projectPath + "/all-projects";
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      setProjects(records ?? []);
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  }, []);

  const getCategories = useCallback(async () => {
    try {
      const path = apiPath.getFAQsCategories;
      const response = await apiGet(path);
      setCategories(response?.data?.results);
    } catch (error) {
      console.error("error in get categories==>>>>", error.message);
    }
  }, []);

  useEffect(() => {
    setValue("projectId", selectedProject);
  }, [selectedProject, setValue]);

  useEffect(() => {
    getProjects();
    getCategories();
  }, [getProjects]);

  const selectedProjectOptions = projects.filter((p) =>
    selectedProject.includes(p._id),
  );

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <form onSubmit={handleSubmit(handleSubmitForm)} method="post">
          <div className="relative w-auto my-6 mx-auto max-w-3xl">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("FAQS_ADD_FAQS")}</h3>
                <button
                  className="ml-auto flex items-center justify-center text-black border-2 rounded-full h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  <span
                    title="Close"
                    className="hover:text-blue-700 transition duration-150 ease-in-out"
                    data-bs-toggle="tooltip"
                  >
                    {" "}
                    <span className="text-[#B8BBBF] text-4xl">×</span>
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1">
                  <div className="w-full">
                    <div
                      onSubmit={handleSubmit(handleSubmitForm)}
                      method="post"
                      className="w-full"
                    >
                      <div className="grid grid-rows-1 grid-cols-1 gap-4">
                        <div className="mb-6 relative w-full">
                          <Autocomplete
                            multiple
                            disableCloseOnSelect
                            id="faq-add-project-autocomplete"
                            options={projects}
                            getOptionLabel={(option) => option?.title ?? ""}
                            isOptionEqualToValue={(option, value) =>
                              option._id === value._id
                            }
                            value={selectedProjectOptions}
                            onChange={(event, newValue) => {
                              setSelectedProject(newValue.map((p) => p._id));
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t("SELECT_PROJECT")}
                                placeholder={t("SELECT_PROJECT")}
                                size="small"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: "rgb(249 250 251)",
                                  },
                                }}
                              />
                            )}
                          />
                          <ErrorMessage message={errors?.projectId?.message} />
                        </div>
                        <div className="mb-6 w-full px-1">
                          <p className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            {t("FAQS_VISIBILITY")}
                          </p>
                          <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:gap-6">
                            <Controller
                              name="showInWebsite"
                              control={control}
                              render={({ field }) => (
                                <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-gray-900 dark:text-white">
                                  <input
                                    type="checkbox"
                                    className="w-4 h-4 rounded border-gray-300 text-[#8FC150] focus:ring-[#8FC150]"
                                    checked={!!field.value}
                                    onChange={(e) =>
                                      field.onChange(e.target.checked)
                                    }
                                  />
                                  {t("FAQ_SHOW_WEBSITE")}
                                </label>
                              )}
                            />
                            <Controller
                              name="showInAgentApp"
                              control={control}
                              render={({ field }) => (
                                <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-gray-900 dark:text-white">
                                  <input
                                    type="checkbox"
                                    className="w-4 h-4 rounded border-gray-300 text-[#8FC150] focus:ring-[#8FC150]"
                                    checked={!!field.value}
                                    onChange={(e) =>
                                      field.onChange(e.target.checked)
                                    }
                                  />
                                  {t("FAQ_SHOW_AGENT_APP")}
                                </label>
                              )}
                            />
                            <Controller
                              name="showInCustomerApp"
                              control={control}
                              render={({ field }) => (
                                <label className="inline-flex items-center gap-2 cursor-pointer text-sm text-gray-900 dark:text-white">
                                  <input
                                    type="checkbox"
                                    className="w-4 h-4 rounded border-gray-300 text-[#8FC150] focus:ring-[#8FC150]"
                                    checked={!!field.value}
                                    onChange={(e) =>
                                      field.onChange(e.target.checked)
                                    }
                                  />
                                  {t("FAQ_SHOW_CUSTOMER_APP")}
                                </label>
                              )}
                            />
                          </div>
                        </div>
                        <Autocomplete
                          multiple
                          options={categories}
                          getOptionLabel={(option) => option.title || ""}
                          value={categories?.filter((category) =>
                            selectedCategory.includes(category._id),
                          )}
                          onChange={(_, newValue) => {
                            setSelectedCategory(
                              newValue.map((category) => category._id),
                            );
                          }}
                          filterSelectedOptions
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={t("SELECT_CATEGORY")}
                              placeholder={t("SELECT_CATEGORY")}
                            />
                          )}
                        />
                        <div className="relative z-0 mb-6 w-full ">
                          <input
                            type="text"
                            name="title"
                            id="title"
                            autoFocus
                            className=" py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                            placeholder=" "
                            maxLength={100}
                            {...register("title", {
                              required: "Please enter title.",
                              minLength: {
                                value: 2,
                                message: "Minimum length must be 2.",
                              },
                              validate: (value) => {
                                return value.trim()
                                  ? true
                                  : "White spaces not allowed.";
                              },
                            })}
                          />
                          <label
                            for="title"
                            maxLength={200}
                            className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                          >
                            {t("FAQS_TITLE")}
                            <span className="text-red-500">*</span>
                          </label>
                          <ErrorMessage message={errors?.title?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-full ">
                          <input
                            type="text"
                            name="titleAr"
                            id="titleAr"
                            autoFocus
                            className=" py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                            placeholder=" "
                            maxLength={100}
                            {...register("titleAr", {
                              required: "Please enter title in arabic.",
                              minLength: {
                                value: 2,
                                message: "Minimum length must be 2.",
                              },
                              validate: (value) => {
                                return value.trim()
                                  ? true
                                  : "White spaces not allowed.";
                              },
                            })}
                          />
                          <label
                            for="titleAr"
                            maxLength={200}
                            className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                          >
                            {t("FAQS_TITLE") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </label>
                          <ErrorMessage message={errors?.titleAr?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-full group">
                          <textarea
                            type="textarea"
                            name="content"
                            id="content"
                            className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                            placeholder=" "
                            {...register("content", {
                              required: "Please enter content.",
                              validate: (value) => {
                                return value.trim()
                                  ? true
                                  : "White spaces not allowed.";
                              },
                            })}
                          />
                          <label
                            for="content"
                            className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                          >
                            {t("FAQS_CONTENT")}
                            <span className="text-red-500">*</span>
                          </label>
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                        <div className="relative z-0 mb-6 w-full group">
                          <textarea
                            type="textarea"
                            name="contentAr"
                            id="contentAr"
                            className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                            placeholder=" "
                            {...register("contentAr", {
                              required: "Please enter content in arabic.",
                              validate: (value) => {
                                return value.trim()
                                  ? true
                                  : "White spaces not allowed.";
                              },
                            })}
                          />
                          <label
                            for="contentAr"
                            className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                          >
                            {t("FAQS_CONTENT") + t("O_ARABIC")}
                            <span className="text-red-500">*</span>
                          </label>
                          <ErrorMessage message={errors?.contentAr?.message} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div />
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  {t("O_BACK")}
                </button>
                <button
                  className="bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150"
                  type="submit"
                >
                  {t("O_ADD")} FAQ
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default AddFAQ;
